export default __webpack_public_path__ + "static/ISOo-9ebed0d782f319299a975228fa7c6fc4.png";